import { Navigate, Route } from "react-router-dom";
import SupervisorDashboard from "../views/supervisor/Dashboard";
import TutorsView from "../views/supervisor/dashboard/tutors";
import PersonalSupervisorInfoPage from "../views/supervisor/dashboard/personalInfo";
import KhetmaView from "../views/supervisor/dashboard/khetma";
import PersonalStudentInfoPage from "../views/supervisor/dashboard/student";
import RequestsPage from "../views/supervisor/dashboard/requests";
import SupervisorSessionsInfoPage from "../views/supervisor/dashboard/sessions";
import IndividualSession from "../views/supervisor/dashboard/individualSession";
import InsightsDashboard from "../views/supervisor/dashboard/insightsDashboard";
import ChatPageWrapper from "../views/chat/ChatPageWrapper";

export default function SupervisorRouter() {
  return (
    <Route path="/supervisor/dashboard/" element={<SupervisorDashboard />}>
      <Route path="/supervisor/dashboard/room" element={<TutorsView />} />
      <Route
        path="/supervisor/dashboard/messages"
        element={<ChatPageWrapper />}
      />
      <Route
        path="/supervisor/dashboard/sessions"
        element={<SupervisorSessionsInfoPage />}
      />
      <Route
        path="/supervisor/dashboard/student/:id"
        element={<PersonalStudentInfoPage />}
      />
      <Route
        path="/supervisor/dashboard/personal-info"
        element={<PersonalSupervisorInfoPage />}
      />
      <Route
        path="/supervisor/dashboard/sessions/:id"
        element={<IndividualSession />}
      />
      <Route
        path="/supervisor/dashboard/requests/"
        element={<RequestsPage />}
      />
      <Route
        path="/supervisor/dashboard/"
        element={<Navigate to="/supervisor/dashboard/room/" />}
      />
      <Route path="/supervisor/dashboard/khetma" element={<KhetmaView />} />
      <Route path="/supervisor/dashboard/tutors/:id/insights" element={<InsightsDashboard />} />
    </Route>
  );
}
